export default __webpack_public_path__ + "static/media/hike.3b3b1b74.jpg";